/* global axios */
import ApiClient from './ApiClient';

class TalkviaCalendarIntegrationAPI extends ApiClient {
  constructor() {
    super('talkvia_calendar_integration', { accountScoped: true });
  }

  update(data) {
    return axios.patch(this.url, { talkvia_calendar_integration: data });
  }

  generateAuthorization(data = {}) {
    return axios.post(`${this.url}/authorization`, data);
  }
}

export default new TalkviaCalendarIntegrationAPI();
